<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import IconifyIcon from '@iconify/svelte'
    import doneIcon from '@iconify/icons-fa-solid/check-circle'
    import {unsubscribe} from 'src/components/main/#services/unsubscribe'

    export let data
    let status

    data = atob(data).split('|')
    if (data[0] && data[1]) {
        try {
            unsubscribe.request({data: { userId: data[0], email: data[1] }})
            status = true
        } catch (err) {
            console.log(err)
            status = false
        }
    } else {
        status = false
    }
</script>

<svelte:head>
    <title>Unsubscribe</title>
    <meta name='robots' content='noindex, follow'/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <section class="main-intro">
            <div class="container">
                {#if status}
                    <div class="text success">
                        <IconifyIcon icon={doneIcon}/> You have successfully unsubscribed from the newsletter
                    </div>
                {:else}
                    <div class="text error">The link is not valid, please try again</div>
                {/if}
            </div>
        </section>
    </svelte:fragment>
</MainLayout>

<style>
    .main-intro {
        padding: 210px 0 150px;
        background: var(--Background) no-repeat center;
        background-size: cover;
        min-height: calc(100vh - 317px);
        display: flex;
        align-items: center;
    }

    .container {
        position: relative;
    }

    .text {
        font-size: 20px;
        color: white;
        padding: 20px;
        text-align: center;
        border-radius: 6px;
    }

    .success {
        background: #48a24c;
    }

    .error {
        background: #f44336;
    }

    @media (max-width: 991px) {
        .text {
            font-size: 18px;
        }
    }

    @media (max-width: 767px) {
        .main-intro {
            padding: 100px 0 70px;
            margin-bottom: -40px;
            overflow: hidden;
        }

        .text {
            padding: 12px;
            font-size: 15px;
        }
    }
</style>
